import { useEffect, useMemo } from "react";
import { useAppDispatch, useAppSelector } from "../../../../../app/hooks";
import { NameIdOption } from "../../../../../common/types/commonTypes";
import { LanguageSkillCode } from "../../../../../features/talents/talentAPI";
import {
  fetchCertificateDefinitionsAutocomplete,
  selectCertificateDefinitions,
  selectCertificateDefinitionsStatus,
} from "../../../../../features/talents/talentsSlice";
import i18n from "../../../../../i18n";

const useCertificatesAutocomplete = () => {
  const dispatch = useAppDispatch();
  const certificateDefinitions = useAppSelector(selectCertificateDefinitions);
  const status = useAppSelector(selectCertificateDefinitionsStatus);
  const language = i18n.language.substring(0, 2) as LanguageSkillCode;

  useEffect(() => {
    if (status !== "idle") return;
    dispatch(fetchCertificateDefinitionsAutocomplete({ language }));
  }, [status, language, dispatch]);

  const certificateOptions: NameIdOption[] = useMemo(
    () =>
      certificateDefinitions
        .map((cert) => ({ id: cert.id, name: cert.name }))
        .sort((a, b) => a.name.localeCompare(b.name, "fi")),
    [certificateDefinitions],
  );

  return {
    certificateOptions,
    isLoading: status === "pending",
  };
};

export default useCertificatesAutocomplete;
